import { useEffect, useRef, useState } from "react";
import { toast } from "sonner";
import api from "@/lib/api";

export default function useUnreadMessages(userId) {
  const [count, setCount] = useState(0);
  const previousCount = useRef(null);

  useEffect(() => {
    if (!userId) return undefined;
    let active = true;
    const refresh = async () => {
      try {
        const { data } = await api.get("/messages/unread-count");
        if (!active) return;
        setCount(data.count);
        if (previousCount.current !== null && data.count > previousCount.current) {
          toast.info("لديك رسالة جديدة في صندوق الرسائل");
        }
        previousCount.current = data.count;
      } catch (error) {
        if (active) console.error("تعذر تحديث عدد الرسائل غير المقروءة", error);
      }
    };

    refresh();
    const interval = window.setInterval(refresh, 15000);
    return () => {
      active = false;
      window.clearInterval(interval);
    };
  }, [userId]);

  return count;
}
